<template>
    <v-container>
        <div class="text-lg-right">
            <v-btn color="primary" text v-on:click="$emit('exit')">{{ exitLabel }}</v-btn>
        </div>
        <v-progress-circular
            class="src-loader"
            v-if="!copyStructureData.items"
            :indeterminate="true"
        />
        <v-form>
            <IterableInput
                :count="index + 1"
                :item="thisItem"
                :readonly="readonly"
                :visible="thisItem.visible"
                :projectId="projectId"
                :moduleKey="moduleKey"
                :userId="userId"
                :handleTabChange="handleTabChange"
                :openQuestionnaire="openQuestionnaire"
                v-bind:key="'section-item-' + _uid + '-' + index"
                v-for="(thisItem, index) in copyStructureData.items"
                v-model="modelData"
            />
        </v-form>
        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="warning" text v-on:click="$emit('cancel')">Cancel</v-btn>
            <v-btn
                :disabled="!complete"
                color="primary"
                text
                v-on:click="$emit('confirm', modelData)"
            >Save</v-btn>
        </v-card-actions>
    </v-container>
</template>

<script>
    import IterableInput from '../questionnaire_template/iterable-input';
    import Store from '../store';
    import { checkVisibility } from '../utilities';

    export default {
        name: 'ItemForm',
        components: {
            IterableInput
        },
        props: {
            exitLabel: String,
            readonly: Boolean,
            structureData: Object, 
            projectId: String,
            moduleKey: String,
            userId: String,
            value: Object,
            handleTabChange: Function,
            openQuestionnaire: Function
        },
        data: function () {
            return {
                complete: false,
                modelData: Object.assign({}, this.value),
                copyStructureData: JSON.parse(JSON.stringify(this.structureData))
            };
        },
        methods: {
            setComplete: function (values) {
                const unfinished = this.store.getUnfinishedQuestions({
                    values
                });
                const unfinishedRequired = unfinished.filter((thisUnfinished) => thisUnfinished.props && thisUnfinished.props.required);

                this.complete = !unfinishedRequired.length;
            },

            setItemVisibility: function () {
                const self = this;
                const map = this.store.getMap();

                Object.keys(map).forEach((key) => {
                    const thisItem = map[key];
                    const { dependencies } = thisItem;

                    if (dependencies) {
                        const isVisible = checkVisibility({
                            item: thisItem,
                            model: this.modelData
                        });

                        // Gotta use $set to make new properties reactive
                        self.$set(thisItem, 'visible', isVisible);

                        dependencies.items.forEach(thisDep => {
                            const { name } = thisDep;

                            self.$watch(() => this.modelData[name], function (newVal, oldVal) {
                                const isVisible = checkVisibility({
                                    item: thisItem,
                                    model: this.modelData
                                });

                                thisItem.visible = isVisible;
                            });
                        });
                    } else {
                        thisItem.visible = true;
                    }
                });
            },
        },

        created: function () {
            this.store = new Store({
                structure: this.copyStructureData,
                values: this.modelData
            });

            this.setItemVisibility();
        },

        mounted: function () {
            // console.log(this.modelData)
            this.setComplete(this.modelData);
        },
        watch: {
            modelData: {
                handler(obj_values){
                    // Why a promise?  This handler runs before component visibility is determined leading to an edge case where validation can be incorrect.
                    // Starting with a promise pushes the validation to the end of the stack allowing visibility and other properties to be set first.
                    Promise.resolve().then(() => {
                        this.setComplete(obj_values);
                    });
                },
                deep: true
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .src-loader {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/item-form.vue